export default theme => ({
  search: {
    width: '100%',
    marginBottom: 20,
    '& input': {
      padding: 6,
      height: 31
    }
  },
  searchWrapper: {
    position: 'relative',
  },
  searchIcon: {
    color: theme.palette.textColor.secondary,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    left: 8,
    top: 14,
    zIndex: 1,
  },
  // the app-wide MuiAutocomplete input padding is !important, so clearing room for the icon needs one too
  searchInput: {
    paddingLeft: '38px !important',
  },
  userWrapper: {
    padding: '4px 8px',
    fontSize: '1rem',
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden'
  },
  day: {
    color: theme.palette.textColor.yellow,
  },
  night: {
    color: theme.palette.textColor.darkBlue,
  },
  inactive: {
    color: theme.palette.textColor.secondary,
  },
  equipmentBlock: {
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Poppins',
  },
  equipmentNumber: {
    color: theme.palette.textColor.white,
    padding: '3px 6px',
    borderRadius: 20,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  equipmentName: {
    marginLeft: 4,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 'max-content',
  },
  usedResource: {
    opacity: 0.3
  },
});
